import { Outlet } from 'react-router';
import { Layout } from 'antd';
import type { PropsWithChildren } from 'react';

export const WebchatLayout = ({ children }: PropsWithChildren) => {
    return <Layout className="webchat-layout">{children ?? <Outlet />}</Layout>;
};

export default WebchatLayout;
